import { styled } from "@mui/material";
import { FOOTER_HEIGHT } from "@/layouts/footer/footer.constants";
import { StyledBaseMain } from "@/layouts/styles";

export const StyledBackground = styled("div")(() => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundImage: "url(/loginPage/background.svg)",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  zIndex: -1,
}));

export const StyledMain = styled(StyledBaseMain)(({ theme }) => ({
  marginTop: FOOTER_HEIGHT,
  padding: "0 36px",
  alignItems: "center",

  [theme.breakpoints.down("tablet")]: {
    padding: "0 20px",
  },
}));
